import React from 'react';
import { useHistory } from 'react-router-dom';
import ButtonComponent from 'components/Button';
import CardListarRequerimento from './CardListaRequerimento';
import { duvidas, servicos } from 'routes/paths';
import * as S from './styles';
import FiltroHistoricoRequerimento from './FiltroHistoricoRequerimento';
import { useDispatch, useSelector } from 'react-redux';
import { formatterFiltroDuvidaServicoFrontToBack } from 'utils/formatter/filtro';
import { fetchGetFormulariosByFilter } from 'store/fetchActions/fetchFormulario';
import { fetchSalvarInputsFormularios } from 'store/fetchActions/fetchInputForm';
import { TIPO_DOCUMENTO } from 'utils/consts';
import { reloadVlibras } from 'utils/acessibilidade';

export default function PageListarRequerimento() {
  const history = useHistory();
  const dispatch = useDispatch();

  const configFiltroSalvo = useSelector(state => state.formulario.configFiltroContribuintePesquisa);
  const user = useSelector(state => state.sefaz.userProfile);

  const [filtros, setFiltros] = React.useState(configFiltroSalvo?.filtro);

  React.useEffect(() => {
    dispatch(fetchSalvarInputsFormularios({}));
  }, [dispatch]);

  const handlePesquisar = (filtro, page = 1, pageSize = 10) => {
    filtro = { ...filtro, tipoPessoaId: TIPO_DOCUMENTO[user?.document_type], numeroDocumento: user?.cpf_cnpj };

    const dadosFormatados = formatterFiltroDuvidaServicoFrontToBack(filtro);
    dispatch(fetchGetFormulariosByFilter(dadosFormatados, page, pageSize));
    setFiltros(filtro);
  };

  const changePage = route => {
    history.push(route);
    reloadVlibras();
  };

  return (
    <S.Page>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '80%' }}>
          <S.Card style={{ display: 'grid', alignItems: 'center' }}>
            <FiltroHistoricoRequerimento
              filtroInicial={filtros}
              handlePesquisar={handlePesquisar}
              salvarFiltro={setFiltros}
            />
          </S.Card>
        </div>
        <div style={{ display: 'inline-table', width: '20%' }}>
          <S.Card>
            <S.TitleCard>Registrar Solicitação</S.TitleCard>
            <S.ContainerButton>
              <ButtonComponent text="Dúvidas e Informações Gerais" clickAction={() => changePage(duvidas)} />
              <ButtonComponent text="Acesso aos Serviços" clickAction={() => changePage(servicos)} />
            </S.ContainerButton>
          </S.Card>
        </div>
      </div>
      <div style={{ width: '100%' }}>
        <CardListarRequerimento filtros={filtros} handlePesquisar={handlePesquisar} />
      </div>
    </S.Page>
  );
}
